// Initialize Firebase
export const config = {
  apiKey: 'AIzaSyDAPHBnFmhc3yrQTf7_S1F7oSd3ZSQOGKc',
  authDomain: 'sportpret-c5679.firebaseapp.com',
  databaseURL: 'https://sportpret-c5679.firebaseio.com',
  projectId: 'sportpret-c5679',
  storageBucket: 'sportpret-c5679.appspot.com',
  messagingSenderId: '48081517838'
}



// WEBPACK FOOTER //
// ./src/firebase/firebaseConfig.js